(function($){
    initCart();
    loadCart();
    initMouseOutCart();

    initCartChangeQuantity();

    if($('#button_add_to_cart').length > 0){
        setTimeout(function() {showPreorder();}, 4000);
        setTimeout(function() {showPreorder();}, 5000);
        setTimeout(function() {showPreorder();}, 6000);
        setTimeout(function() {showPreorder();}, 7000);
        setTimeout(function() {showPreorder();}, 8000);
        setTimeout(function() {showPreorder();}, 9000);
        setTimeout(function() {showPreorder();}, 10000);
    }

})(jQuery)

function showPreorder() {
    var preorder_text = $('#preorder-note').val();
    var button_text = $('#button_submit_add_to_cart').val();
    if(preorder_text!=''){
        if(button_text!='') {
            $('#button_add_to_cart').text(button_text);
        }
    }
}

function initCartChangeQuantity() {

    $('.product-quantity-change').on('click', function () {

        var selected_qty = parseInt($('#product_selected_quantity').val());
        var max_qty = parseInt($('#product_max_quantity').val());
        var new_qty = selected_qty;

        if ($(this).hasClass('icon-plus')) {
            if (max_qty > selected_qty) {
                new_qty++;
            }
        } else {
            if (new_qty > 1) {
                new_qty--;
            }
        }
        new_qty = (isNaN(new_qty)) ? 1 : new_qty;
        $('#product_selected_quantity').val(new_qty)

        if (max_qty == new_qty) {
            $('.icon-plus img').hide();
        } else {
            $('.icon-plus img').show();
        }
    });
}
function initMouseOutCart() {
    var timeout;
    $('#smallBasket').on("mouseover", function(e) {
        clearTimeout(timeout);
    });
    $('#smallBasket').on("mouseout", function() {
        timeout = setTimeout(function() { $("#smallBasket").hide(); }, 5000);
    });
    timeout = setTimeout(function() { $("#smallBasket").hide(); }, 5000);
}

function addItemToCart(product_id) {

    var qty = parseInt($('.product_selected_qt_' + product_id).val());
    var variant_id = $('#product-select-' + product_id).val();

    $( ".swatch-element input[type='radio']" ).each(function() {
        if($( this ).is(':checked')) {
            variant_id = $(this).val();
        }
    });

    var pre_order = 0;
    if($('form').hasClass('preorder-now-active')){
        pre_order = 1;
    }

    if(!qty){
        qty = 1;
    }

    var preorder_text = $('#preorder-note').val();

    if(pre_order == 1){
        var data = {
            "id": variant_id,
            "quantity": qty,
            "properties":{
                "pre-order": preorder_text
            }
        }
    }else{
        var data = {
            "id": variant_id,
            "quantity": qty
        }
    }
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() {
            initCart();
            loadCart();
            $('#smallBasket').fadeIn(300);
        },error: function(error){
            if(error.responseJSON.description){
                alert(error.responseJSON.description);
            }
        }
    });
}

function loadCart() {
    jQuery.ajax({
        type: 'GET',
        url: '/cart.json',
        dataType: 'jsonp',
        success: function(data) {

            var item_count = data['item_count'];
            var total_price = data['total_price']/100;

            //If there are items in cart
            if ( item_count > 0 ) {

                // cart count
                jQuery('.cart-count').text(item_count);

                // mini cart data
                jQuery('.mini-cart').attr('id','mini-cart');
                jQuery('.mini-cart-subtotal').text( '$' + total_price.toFixed(2) );

                var cart_list = [];

                for( var i = 0; i < item_count; i++ ){
                    if(data['items'][i]) {
                        if (data['items'][i]['id']) {

                            var item_id = data['items'][i]['id'];
                            var product_title = data['items'][i]['product_title'];
                            var product_handle = data['items'][i]['handle'];
                            var quantity = data['items'][i]['quantity'];
                            var line_price = data['items'][i]['price'] / 100;
                            var product_url = data['items'][i]['url'];
                            var image_url = data['items'][i]['image'];
                            var variants = data['items'][i]['variant_options'];
                            var product_oz = Math.ceil(data['items'][i]['grams']/28.34952);

                            var selling_plan_allocation = data['items'][i]['selling_plan_allocation'];

                            var options = [];
                            for (var o = 0; o < variants.length; o++) {
                                var selected = data['items'][i]['variant_options'][o];
                                if (selected !== 'Default Title') {
                                    options.push(selected + '<br>');
                                }
                            }
                            var selected_options = options.join('');
                            var item_variant_id = data['items'][i]['variant_id'];

                            if(data['items'][i]['options_with_values'][1]) {
                                var html = '<div class="small-basket-item">\n' +
                                    '              <div class="small-basket-left">\n' +
                                    '                <div class="basket-image">\n' +
                                    '                   <a href="' + product_url + '">\n' +
                                    '                       <img src="' + image_url + '">\n' +
                                    '                    </a>\n' +
                                    '                 </div>\n' +
                                    '              </div>\n' +
                                    '              <div class="small-basket-right">\n' +
                                    '                    <div class="basket-title">' + product_title + '</div>\n' +
                                    '                    <div class="basket-options basket-subtotal">' + line_price.toFixed(2) + '</div>\n' +
                                    '              <br>\n' +
                                    '              <div class="basket-options">SIZE: ' + data['items'][i]['options_with_values'][0].value + '</div>\n' +
                                    '              <div class="basket-options">COLOR: ' + data['items'][i]['options_with_values'][1].value + '</div>\n' +
                                    '              <div class="cart-quantity mt-3 change_product_count small_cart"  data-handle="' + data['items'][i]['handle'] + '"  data-variant="' + data['items'][i]['variant_id'] + '">\n' +
                                    '                    <button class="quantity-btn button-quantity-change quantity-decrease-btn icon-minus" name="button" type="button"><img src="https://cdn.shopify.com/s/files/1/0739/2881/t/49/assets/minus.svg?v=1627283154" alt="minus"></button>\n' +
                                    '                    <input id="product_quantity_' + data['items'][i]['variant_id'] + '" class="quantity-input" max="10000" min="1" type="number" value="' + quantity + '">\n' +
                                    '                    <button class="quantity-btn button-quantity-change quantity-increase-btn icon-plus" name="button" type="button"><img src="https://cdn.shopify.com/s/files/1/0739/2881/t/49/assets/plus.svg?v=1627283695" alt="plus"></button>\n' +
                                    '              </div>\n' +
                                    '   </div>\n' +
                                    '</div>';
                            }else{
                                var html = '<div class="small-basket-item">\n' +
                                    '              <div class="small-basket-left">\n' +
                                    '                <div class="basket-image">\n' +
                                    '                   <a href="' + product_url + '">\n' +
                                    '                       <img src="' + image_url + '">\n' +
                                    '                    </a>\n' +
                                    '                 </div>\n' +
                                    '              </div>\n' +
                                    '              <div class="small-basket-right">\n' +
                                    '                    <div class="basket-title">' + product_title + '</div>\n' +
                                    '                    <div class="basket-options basket-subtotal">' + line_price.toFixed(2) + '</div>\n' +
                                    '              <br>\n' +
                                    '              <div class="cart-quantity mt-3 change_product_count small_cart"  data-handle="' + data['items'][i]['handle'] + '"  data-variant="' + data['items'][i]['variant_id'] + '">\n' +
                                    '                    <button class="quantity-btn button-quantity-change quantity-decrease-btn icon-minus" name="button" type="button"><img src="https://cdn.shopify.com/s/files/1/0739/2881/t/49/assets/minus.svg?v=1627283154" alt="minus"></button>\n' +
                                    '                    <input id="product_quantity_' + data['items'][i]['variant_id'] + '" class="quantity-input" max="10000" min="1" type="number" value="' + quantity + '">\n' +
                                    '                    <button class="quantity-btn button-quantity-change quantity-increase-btn icon-plus" name="button" type="button"><img src="https://cdn.shopify.com/s/files/1/0739/2881/t/49/assets/plus.svg?v=1627283695" alt="plus"></button>\n' +
                                    '              </div>\n' +
                                    '   </div>\n' +
                                    '</div>';
                            }
                            cart_list.push(html);
                        } //endif
                    }
                } // endfor

                jQuery('.mini-products-list').html( cart_list.join('') );


                jQuery('.small_cart .button-quantity-change').on('click', function(){

                    var product_max_count = 0;
                    var product_variant_id = $(this).closest('.change_product_count').attr('data-variant');
                    var product_handle = $(this).closest('.change_product_count').attr('data-handle');
                    var new_element_quantity = parseInt($('#product_quantity_' + product_variant_id).val());


                    if($(this).hasClass('icon-plus')) {

                        $.getJSON('/products/' + product_handle+ '.js', function (product) {
                            for (productVariant in product.variants) {
                                if(product.variants[productVariant].id == product_variant_id){
                                    product_max_count = product.variants[productVariant].inventory_quantity
                                    new_element_quantity++;
                                    if(product_max_count>=new_element_quantity) {
                                        updateItemCountInCart(product_variant_id,new_element_quantity);
                                        $('#product_quantity_' + product_variant_id).val(new_element_quantity);
                                    }else{
                                        alert('You have added the maximum stock of this item to your cart');
                                    }
                                }
                            }
                        });


                    }else{
                        new_element_quantity--;
                        if(new_element_quantity>=0) {
                            updateItemCountInCart(product_variant_id,new_element_quantity);
                            $('#product_quantity_' + product_variant_id).val(new_element_quantity);
                        }
                    }
                });
            }else{
                $('.mini-products-list').empty();
                $('.no-items-in-cart').show();
                $('.mini-cart-subtotall').text('$0');
            }
        }
    });
}

function updateItemCountInCart(variant_id,new_count) {

    var data = { updates: {} };
    data.updates[variant_id] = new_count;

    jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(data) {
            initCart();
            loadCart();
        }
    });
}

function initCart() {
    jQuery.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(data) {

            var item_counts_in_cart = data.items.length;
            if(item_counts_in_cart>0) {
                $('#cart_current_quantity').show().text(data.items.length);
                $('#small_cart_elements_count').text(data.items.length);
                $('.no-items-in-cart').hide();
            }else{
                $('#cart_current_quantity').hide();
                //$('.mini-products-list').empty();
                $('.no-items-in-cart').show();
                $('#small_cart_elements_count').text(0);
                $('.mini-cart-subtotal').text('$0');
            }
        }
    });
}

